<template>
  <div class="tables" style="padding:0;">
    <table v-bind:style="{'width':width}">
      <thead>
      <tr>
        <th class="tableTh" v-for="(item,index) in tableHead" :key="index">{{item}}</th>
      </tr>
      </thead>
      <tbody style="position: absolute;left: 4%;top: 30px;right: 0;bottom: 0;">
      <tr v-for="(item, index) in tableData2" :key="index" @click="chooseIt(index)"
          v-bind:style="{'background': index === activeIndex ? '#d5d5d5': ''}">
        <td class="tableTd"><span class="myspan" :title="item.copyTime">{{item.time}}</span></td>
        <td class="tableTd"><span class="myspan" :title="item.applicant">{{item.applicant}}</span></td>
        <td class="tableTd"><span class="myspan" :title="item.typeArr">{{computedsType(item.images)}}</span></td>
        <td class="tableTd"><span class="myspan"
                                  :title="item.position_overview_list">{{item.position_overview_list}}</span></td>
        <td
          class="tableTd"><span class="myspan" :title="item.doctor_conclusion">{{item.doctor_conclusion | filterConclusion}}</span>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
  import _ from 'lodash';
  import moment from 'moment';
  import Util from "../utils/utils.js";
  import axios from 'axios';
  import api from '../api';

  let that;
  export default {
    props: {
      tableHead: Array,
      tableData: Array,
      width: String,
      wordBook: Object,
    },
    data() {
      return {
        activeIndex: 0,
        tableData2: [],
        knowledgeDic: [],
      }
    },
    async created() {
      for (let i = 0; i < this.tableData.length; i++) {
        if (!!this.wordBook[this.tableData[i].doctor_conclusion]) {
          this.tableData[i].doctor_conclusion = this.wordBook[this.tableData[i].doctor_conclusion].name;
        }

      }
      // 请求皮肤病知识库
      const response = await axios.request({
        method: 'get',
        url: api.knowledgeDic,
      });
      this.knowledgeDic = response.data;
    },
    watch: {
      tableData() {
        let arr = _.clone(this.tableData);
        this.tableData2 = _.sortBy(arr, item => -item.id);
      },
    },
    methods: {
      chooseIt(index) {
        this.activeIndex = index;
        this.$emit("message", {index});
      },
      computedsType(imgs) {
        let typeArr = [];
        for (let j = 0; j < imgs.length; j++) {
          let typeString = "";
          switch (imgs[j].type) {
            case Util.SOAK.code:
              typeString = "皮肤镜";
              break;
            case Util.POLARRIZE.code:
              typeString = "皮肤镜";
              break;
            case Util.GENERAL.code:
              typeString = "大体图/伍德灯";
              break;
            case Util.CT.code:
              typeString = "CT";
              break;
            case Util.BC.code:
              typeString = "B超";
              break;
            case Util.PATHOlOGY.code:
              typeString = "病理";
              break;
          }
          typeArr.push(typeString);
        }
        typeArr = _.uniq(typeArr);
        return typeArr.toString();
      }
    },
    beforeCreate() {
      that = this;
    },
    filters: {
      filterConclusion(value) {
        const obj = that.knowledgeDic;
        if (obj[value]) {
          return obj[value].name;
        }
      }
    },
  };
</script>
<style scoped lang="less">
  .tables {
    width: 100%;
    height: 100%;
  }

  tbody::-webkit-scrollbar {
    width: 5px;
    height: 100%;

  }

  tbody::-webkit-scrollbar-track-piece {
    background: #fff;
    -webkit-border-radius: 6px;
  }

  tbody::-webkit-scrollbar-thumb:vertical {
    background-color: #61a2bf;
    -webkit-border-radius: 6px;
  }

  * {
    margin: 0;
    padding: 0;
  }

  tr {
    background: #eff3f7;
    height: 35px;
    line-height: 35px;
  }

  td {
    white-space: nowrap;
  }

  th {
    white-space: nowrap;
  }
  table {
    /*设置相邻单元格的边框间的距离*/
    border-spacing: 0;
    /*表格设置合并边框模型*/
    text-align: center;
  }

  /*关键设置 tbody出现滚动条*/
  table tbody {
    display: block;
    overflow-y: auto;
    overflow-x: hidden;
  }

  table tbody tr {
    background: #eff3f7;
    border-top: 1px solid #fff;
    padding: 5px 10px;
  }

  table tbody tr:nth-last {
    border-bottom: 1px solid #fff;
  }

  table tbody td {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px;
    cursor: pointer;

    .myspan {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

  }

  table tbody tr:hover {
    background: #d5d5d5;
  }

  table thead,
  tbody tr {
    display: table;
    width: 100%;
    table-layout: fixed;
  }

  /*关键设置：滚动条默认宽度是16px 将thead的宽度减16px*/
  table thead {
    width: 100%;
  }


  table thead th {
    // background: #ccc;
    color: #61a2bf;
    font-size: 14px;
  }
</style>
